<template>
  <div class="GlobalTitlte">
    <h2>{{ En }}</h2>
    <div :class="[flex ? 'flex-s' : '']">
      <WordWithUnderlineVue :words="Zh" />
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import WordWithUnderlineVue from "./WordWithUnderline.vue";

export default {
  name: "GlobalTitlte",
  components: { WordWithUnderlineVue },
  props: {
    flex: {
      type: String,
      default: '',
    },
    En: {
      type: String,
      require: true,
    },
    Zh: {
      type: String,
      require: true,
    },
  },
};
</script>

<style lang="less" scoped>
h2 {
  margin: 2px 0 4px;
  font-size: 50px;
  color: @text-title-ZH-color;
  font-weight: 400;
}

.flex-s {
  display: flex;
  align-items: end;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalTitlte.vue